import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TabSkeletonComponent } from './tab-skeleton.component';

@NgModule({
  declarations: [TabSkeletonComponent],
  imports: [CommonModule, IonicModule],
  exports: [TabSkeletonComponent],
})
export class TabSkeletonModule {}
